import { render, staticRenderFns } from "./create.modal.vue?vue&type=template&id=0a170d56&scoped=true&"
import script from "./create.modal.vue?vue&type=script&lang=js&"
export * from "./create.modal.vue?vue&type=script&lang=js&"
import style0 from "./create.modal.vue?vue&type=style&index=0&id=0a170d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a170d56",
  null
  
)

export default component.exports